/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_File_UnreadableInputs */

const en_issue_file_unreadable = /** @type {(inputs: Issue_File_UnreadableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cannot be read as an Excel file`)
};

/**
* | output |
* | --- |
* | "cannot be read as an Excel file" |
*
* @param {Issue_File_UnreadableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_file_unreadable = /** @type {((inputs?: Issue_File_UnreadableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_File_UnreadableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_file_unreadable(inputs)
});